import React, { ReactNode } from 'react'

import { Content } from './styles'

interface DialogContentProps {
  children: string | ReactNode
}

export function DialogContent({ children }: DialogContentProps) {
  if (typeof children === 'string') {
    return <Content>{children}</Content>
  }

  return children
}
